var pwaDOTD = function(){
	const init = () => {
		// Only run this on the homepage
		if ('serviceWorker' in navigator && document.querySelector('#ProductDetails') !== null) window.addEventListener('load', registerApp);
	},
	registerApp = () => {
		navigator.serviceWorker.register('/sw', { type: 'module' }).then(function (registration) {
             		if ('pushManager' in registration) {
                        	//console.log('Service worker registered.');
                    	} else {
                        	// The service worker doesn't support push
                        	//console.log('Service worker registered, but brower does not support push.');
                    	}
		}).catch(function (err) {
              	// registration failed :(
                    //console.log('ServiceWorker registration failed: ', err);
     		});
	};
	return{
		Init: init
	};
};

(function(){
	const pwa = new pwaDOTD();
	pwa.Init();
})();